export default __webpack_public_path__ + "static/media/node-systems.82c87309.svg";